import Vue from 'vue'
import Vuex from 'vuex'
import stock from './modules/stock'
import services from './modules/services'
import manager from './modules/manager'
import impersonation from './modules/impersonation'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    module: null,
    modules: []
  },
  mutations: {
    setModule (state, module) {
      state.module = module
    },
    addModule (state, module) {
      state.modules.push(module)
    }
  },
  actions: {
    handleModuleNavigation ({ state, commit }, to) {
      const from = state.module

      if (state.module !== to) {
        commit('setModule', to)

        window.vue.$emit('moduleChanged', { from, to })
      }
    }
  },
  modules: {
    services,
    stock,
    manager,
    impersonation
  }
})
